import React,{ useState, useContext, useEffect } from 'react'
import { Table,Button } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'
import "./FAQ.css"
import { LanguageContext } from '../Language/LanguageContext'
import { NotifyContext } from '../Library/Notify'
import { faq_list, deletefaq } from '../Network/FAQ'
import { Loading, TablePagination, Container, HeaderTitle } from '../Library'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash, faPen } from '@fortawesome/free-solid-svg-icons'
import dayjs from 'dayjs'
import { setDocumentTitle } from '../AppTitle'
import { AlertModalContext } from '../Library/AlertModalContext'

function FAQ() {
    const history = useHistory();
    const alertModal = useContext(AlertModalContext)
    const langCx = useContext(LanguageContext);
    const lang = langCx.lang.FAQ;
    const langError = langCx.lang.error;
    const notifyCx = useContext(NotifyContext);
    const [isLoading, setLoading] = useState(false);

    const [listfaq, setListfaq] = useState([]);

    const [currentPage, setCurrentPage] = useState(1);
    const perPage = 10
    const totalPage = Math.ceil(listfaq.length / perPage)
    const indexOfLast = currentPage * perPage
    const indexOfFirst = indexOfLast - perPage


    const fetchData = () =>{
        faq_list(
            (data)=>{
                setListfaq(data);
                setLoading(false);
            },
            (error)=>{
                notifyCx.showNotify("Something wrong", error.message, 2)
                setLoading(false)
            }
        )
    }
    const removefaq = (id) =>{
        alertModal.setTitle(lang.delete_faq)
        alertModal.setDescription(lang.delete_sure)
        alertModal.setAlertType("EXTREME")
        alertModal.setButton([
            {
                title: langCx.lang.confirm.ok,
                variant: "danger",
                onClick: ()=>{ 
                    alertModal.setIsShow(false)
                    setLoading(true)
                    deletefaq(id,
                        ()=>{
                            notifyCx.showNotify(lang.deleted_faq,lang.deleted_faq_desc, 0)
                            fetchData();
                        },
                        (error)=>{
                            setLoading(false)
                            notifyCx.showNotify("Something wrong", error.message, 2)
                        })
                }
            },
            {
                title: langCx.lang.confirm.cancel,
                variant: "secondary",
                onClick: ()=>{ 
                    alertModal.setIsShow(false) 
                }
            }
        ])
        alertModal.setIsShow(true)
        
    }

    useEffect(()=>{
        setDocumentTitle("FAQ")
        fetchData()
    },[])


    return (
        <Container id="faq" topbarTitle={langCx.lang.sidebar.faq}>
            <HeaderTitle title={lang.list_faq}/>
            <div className="button-container">
                <Button className="addbutton" onClick={()=>history.push("/faq/create")}>
                    {lang.add_faq}
                </Button>
            </div>
            <div className="table-container">
                <Table 
                className="table-FAQ"
                hover>
                    <thead>
                        <tr>
                            <th>{lang.id}</th>
                            <th>{lang.question}</th>
                            <th>{lang.answer}</th>
                            <th>{lang.create_date}</th>
                            {/* <th>{lang.create_by}</th> */}
                            <th>{lang.update_date}</th>
                            {/* <th>{lang.update_by}</th> */}
                            <th>{lang.action}</th>
                        </tr>
                    </thead>
                    <tbody>
                        { listfaq.slice(indexOfFirst, indexOfLast).map((item, key)=>
                            <FAQRow
                            key={key}
                            id={item.id}
                            question={item.question}
                            answer={item.answer}
                            createdDate={item.createdDate}
                            createdBy={item.createdBy}
                            updatedDate={item.updatedDate}
                            updatedBy={item.updatedBy}
                            onClick={()=>history.push("/faq/edit/"+item.id)}
                            onClickDelete={()=>removefaq(item.id)}
                            />
                        )}
                        { listfaq.length === 0 ?
                        <tr style={{textAlign: 'center'}}>
                            <td colSpan={7}>No FAQ</td>
                        </tr>
                        : null
                        }
                    </tbody>
                </Table>
            </div>
            <div className="pagination">
                <TablePagination
                dataLength={totalPage}
                size={10}
                currentPage={currentPage}
                handlerPaginationClick={(page)=>{ setCurrentPage(page) }}
                nextClick={()=>{ setCurrentPage(currentPage + 1) }}
                prevClick={()=>{ setCurrentPage(currentPage - 1) }}
                firstPageClick={(first)=>{ setCurrentPage(first) }}
                lastPageClick={(last)=>{ setCurrentPage(last) }}
                disabledPrev={currentPage === indexOfFirst + 1}
                disabledNext={currentPage === totalPage}
                />
            </div>         
        </Container>
    )
}
function FAQRow(props){
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.FAQ

    const convertDate = (toDate) =>{
        let date = new Date(toDate)
        let formatted = dayjs(date).format("D MMM YYYY H:mm")
        return formatted
    }
    return(
        <tr className="FAQ-row"
        >
            <td>{props.id}</td>
            <td>{props.question}</td>
            <td>{props.answer}</td>
            <td>{convertDate(props.createdDate)}</td>
            {/* <td>{props.createdBy}</td> */}
            <td>{convertDate(props.updatedDate)}</td>
            {/* <td>{props.updatedBy}</td> */}
            <td>
                <Button size="sm" style={{marginRight: 5}}
                onClick={props.onClick}
                > <FontAwesomeIcon icon={faPen}/></Button>
                <Button size="sm" variant="danger"
                onClick={props.onClickDelete}>
                    <FontAwesomeIcon icon={faTrash}/>
                </Button>
            </td>
        </tr>
    )
}

export default FAQ